import { createFileRoute, stripSearchParams } from '@tanstack/react-router';

import { zodEsgDataQueryParamsSchema } from '~/data/analytics/useQueryEsgData/validations';

import { EsgAnalytics } from '~/modules/analytics/esg';

import { i18n } from '~/utils';
import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';
import { getRouteHead } from '~/utils/routeUtils';
import { stripUnknownSearchParams } from '~/utils/stripUnknownSearchParams';

import { routeParams } from './-routeParams';

const title = i18n.t(($) => $.esg.pageTitle, { ns: 'analytics' });

export const Route = createFileRoute('/(main)/analytics/esg/')({
  beforeLoad: createProtectedRoute({
    routePath: '/analytics/esg/',
    ...routeParams,
  }),
  component: EsgAnalytics,
  head: () => getRouteHead(title),
  search: {
    middlewares: [
      stripSearchParams(zodEsgDataQueryParamsSchema.parse({})),
      stripUnknownSearchParams(zodEsgDataQueryParamsSchema.parse({})),
    ],
  },
  staticData: {
    AppBar: {
      title,
    },
  },
  validateSearch: zodEsgDataQueryParamsSchema,
});

export const ANALYTICS_ESG = buildRouteExport({ Route, ...routeParams });
